<template>
  <div>
    <h1>Dashboard</h1>
    <ElCard :key="s.title" v-for="s in stats.cards" class="dashcard">
      <span class="title">
        {{ s.title }}
      </span>
      <span class="value">
        {{ s.value }}
      </span>
    </ElCard>

    <br clear="all" />
    <table style="width: 400px" class="summary">
      <tr>
        <th>User</th>
        <th>Login</th>
        <th>Member since</th>
      </tr>
      <tr :key="i" v-for="(l, i) in stats.logins">
        <td>{{ l.name }}</td>
        <td>{{ (l.login / 1000) | moment("from") }}</td>
        <td>
          {{ (l.joined / 1000) | moment("from") }},
          {{ (l.joined / 1000) | moment("D-M-Y") }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: "Dashboard",
  mounted() {
    console.log("## mounted dashboard")
  },

  created() {
    // fetch some stats
    this.$API.get("/admin/dashboard").then(resp => {
      console.log("st: ", resp.data)
      this.stats = resp.data
    })
  },

  data() {
    return {
      stats: {}
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 1.2em;
  color: #0047ab;
  /*border-bottom: 2px solid #0047AB;*/
}

.value {
  font-size: 3em;
  color: #0047ab;
}

.dashcard {
  float: left;
  width: 12em;
  height: 12em;
  margin: 1em;
}

.summary table {
  border-collapse: collapse !important;
  border: 1px solid blue;
}

.summary th,
td {
  border-collapse: collapse;
  font-size: small;
  line-height: 0.9em;
  text-align: left;
  border: 1px solid grey;
  font-weight: normal;
  padding: 0.2em;
}

.summary tr:nth-child(odd) {
  background-color: white;
}

.summary th {
  background-color: #0047ab;
  color: ivory;
  height: 1.2em;
  padding: 2px;
}
</style>
